export const eligibility = {
  menuLabel: 'Eligibility',
  text: 'Eligibility',
  error: 'Unable to load eligibility page',
};
